import { ICargo } from "./cargo";
import { CargoType } from "./cargoTypeEnum";
import { Guid } from "@pmis3/utils"

type ICargoRequiredFields = {
    key: keyof ICargo;
}

export class CargoHelper {
    private static getRequiredFieldsForCargo(): ICargoRequiredFields[] {
        return [
            { key: 'cargoTypeId' }, { key: 'unitId' }, { key: 'quantity' }
        ]
    }

    static cargoFieldIsValid(field: keyof ICargo, cargo: ICargo) {
        const requiredFields = this.getRequiredFieldsForCargo();

        const fieldConstraint = requiredFields.find(req => req.key === field);
        if (!fieldConstraint) return true;

        const value = cargo[field];
        return value == null || value == undefined ? false : true;
    }

    static cargoIsValid(cargo: ICargo): boolean {
        return this.getRequiredFieldsForCargo().every(fieldConstraint => this.cargoFieldIsValid(fieldConstraint.key, cargo));
    }
}